<template>
    <div v-if="json" class="news-snippet-block">
        <div class="capper">
            <div class="capper-padded" data-aos="fade-up" >
                <Lines v-if="isHomePage" type="top" label="Community Blog"/>
                <Lines v-else type="top" label="Featured Blogs"/>
                <div class="news-links">
                    <template v-for="(item, index) in json" :key="`news${index}`">
                        <div class="news-link" data-aos="fade-up" >
                            <div class="news-link2">
                                <div>
                                    <router-link
                                        :to="'/' + item.slug"
                                        :aria-label="item.title"
                                    >
                                        <div class="feaured-image" v-if="!isHomePage">
                                            <div v-if="item?.featuredNewsImage?.[0]?.bgStyle" class="bgimg" :style="item?.featuredNewsImage?.[0]?.bgStyle"/>
                                            <TtmotifIcon v-else class="tt-motif-svg" aria-label="Insomniac" />
                                        </div>
                                        <span>{{item.title}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div v-if="index===0" class="line"></div>
                    </template>
                </div>
                <Lines v-if="isHomePage" type="bottom" label="All Blogs" link="/community#all-blogs"/>
            </div>
        </div>
    </div>
</template>

<script>
import Lines from "@/components/pieces/Lines";
//import Link from "@/components/pieces/Link";
import TtmotifIcon from "@/components/svgs/Ttmotif.vue";

export default {
    name: "NewsSnippetBlock",
    components: {
        TtmotifIcon,
        Lines,
        //Link
    },
    props: {
        json: {
            type: Object,
            required: true,
        },
        isHomePage: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            window: window,
        };
    },
    mounted() {
    },
    methods: {},
};
</script>